/**
 * @generated SignedSource<<c1494a6a7b49cbec631cf19fe74c4af8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestonePickerRecentlyUpdatedMilestones$data = {
  readonly id: string;
  readonly milestones: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"MilestonePickerMilestone">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "MilestonePickerRecentlyUpdatedMilestones";
};
export type MilestonePickerRecentlyUpdatedMilestones$key = {
  readonly " $data"?: MilestonePickerRecentlyUpdatedMilestones$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestonePickerRecentlyUpdatedMilestones">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "MilestonePickerRecentlyUpdatedMilestones"
};

(node as any).hash = "d8ba45b33bcbd16ccee7ebe8b72bedc4";

export default node;
